import React from 'react';

const Modal = ({header, children}) => {

  const toggleOverlay = () => {
    document.querySelector('.overlay').classList.toggle('modal__active');
  }

  return (
    <div className="overlay" onClick={toggleOverlay}>
      <div onClick={(e) => e.stopPropagation()} className="overlay__modal">
        <div className="overlay__modal__header">
          {header}
        </div>
        <div className="overlay__modal__body">
          {children}
        </div>
      </div>
    </div>
  );
} 

export default Modal